var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{style:(("padding-top: " + _vm.ratio + "%"))}),_c('div',{staticClass:"position-absolute fill"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }